import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ReactApexChart from 'react-apexcharts';
import { formatMonth } from 'utils/formatters';

const CashFlowChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <Paper elevation={1} sx={{ p: 3, height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography color="text.secondary">No cash flow data available</Typography>
      </Paper>
    );
  }

  const categories = data.map((item) => `${formatMonth(item.month)} ${item.year}`);
  const series = [
    {
      name: 'BRL',
      data: data.map((item) => parseFloat(item.brl) || 0),
    },
    {
      name: 'USD',
      data: data.map((item) => parseFloat(item.usd) || 0),
    },
  ];

  const options = {
    chart: {
      type: 'line',
      toolbar: { show: false },
      zoom: { enabled: false },
      fontFamily: 'inherit',
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    colors: ['#3B82F6', '#10B981'],
    xaxis: {
      categories,
      labels: {
        style: { fontSize: '11px' },
      },
    },
    yaxis: [
      {
        title: { text: 'BRL', style: { fontSize: '11px' } },
        labels: {
          formatter: (val) => {
            if (val == null) return 'R$ 0';
            if (val >= 1000000) return `R$ ${(val / 1000000).toFixed(1)}M`;
            if (val >= 1000) return `R$ ${(val / 1000).toFixed(0)}k`;
            return `R$ ${val.toFixed(0)}`;
          },
          style: { fontSize: '10px' },
        },
      },
      {
        opposite: true,
        title: { text: 'USD', style: { fontSize: '11px' } },
        labels: {
          formatter: (val) => {
            if (val == null) return '$ 0';
            if (val >= 1000000) return `$ ${(val / 1000000).toFixed(1)}M`;
            if (val >= 1000) return `$ ${(val / 1000).toFixed(0)}k`;
            return `$ ${val.toFixed(0)}`;
          },
          style: { fontSize: '10px' },
        },
      },
    ],
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      fontSize: '12px',
    },
    tooltip: {
      y: {
        formatter: (val, { seriesIndex }) => {
          const safeVal = val ?? 0;
          if (seriesIndex === 0) {
            return new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(safeVal);
          }
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          }).format(safeVal);
        },
      },
    },
    grid: {
      borderColor: '#e0e0e0',
      strokeDashArray: 3,
    },
    markers: {
      size: 4,
      hover: { size: 6 },
    },
  };

  return (
    <Paper elevation={1} sx={{ p: 2, height: 300 }}>
      <Box sx={{ height: '100%' }}>
        <ReactApexChart
          options={options}
          series={series}
          type="line"
          height="100%"
        />
      </Box>
    </Paper>
  );
};

export default CashFlowChart;
